import { backgroundOrange, darkOrange, orange } from '@/theme/colors'
import styled from 'styled-components'

export const TabBar = styled.div`
	display: flex;
	background: white;
	border: 1px solid #f0e0d6;
	border-radius: 10px;
	padding: 0.25rem;
	margin-bottom: 1rem;
	gap: 0.25rem;
`

export const TabButton = styled.button<{ $active: boolean }>`
	flex: 1;
	background: ${({ $active }) => ($active ? backgroundOrange : 'transparent')};
	color: ${({ $active }) => ($active ? darkOrange : '#6b7280')};
	border: none;
	padding: 0.5rem 0.75rem;
	border-radius: 8px;
	font-size: 0.875rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s ease;

	&:hover {
		color: ${darkOrange};
	}

	${({ $active }) =>
		$active &&
		`
		box-shadow: inset 0 0 0 1px ${orange}33;
	`}
`
